import {onDomReady} from "./observer.js";

class VipSubscribeForm {
    constructor() {
        this.options = {
            planRadios: '[data-vip-plan]',
            requiredCheckboxes: '[data-vip-required-checkbox]',
            subscribeBtn: '[data-vip-subscribe-btn]',
            subscribeHint: '[data-vip-subscribe-hint]',
        };

        this.elements = {
            planRadiosElements: document.querySelectorAll(this.options.planRadios),
            requiredCheckboxesElements: document.querySelectorAll(this.options.requiredCheckboxes),
            subscribeBtnElement: document.querySelector(this.options.subscribeBtn),
            subscribeHintElement: document.querySelector(this.options.subscribeHint),
        };

        this.init();
    }

    init() {
        if (this.elements.subscribeBtnElement) {
            const planRadiosElementsVar = this.elements.planRadiosElements;
            const requiredCheckboxesElementsVar = this.elements.requiredCheckboxesElements;

            planRadiosElementsVar.forEach((planRadioCur) => {
                planRadioCur.addEventListener('change', () => {
                    this.updateButtonState();
                });
            });

            requiredCheckboxesElementsVar.forEach((checkboxCur) => {
                checkboxCur.addEventListener('change', () => {
                    this.updateButtonState();
                });
            });

            this.updateButtonState();
        }
    }

    isPlanSelected() {
        return Array.from(this.elements.planRadiosElements).some((radio) => radio.checked);
    }

    areCheckboxesChecked() {
        return Array.from(this.elements.requiredCheckboxesElements).every((checkbox) => checkbox.checked);
    }

    updateButtonState() {
        const planOk = this.isPlanSelected();
        const checksOk = this.areCheckboxesChecked();
        const shouldEnable = planOk && checksOk;

        this.elements.subscribeBtnElement.disabled = !shouldEnable;
        this.elements.subscribeBtnElement.setAttribute('aria-disabled', String(!shouldEnable));

        if (this.elements.subscribeHintElement) {
            if (shouldEnable) {
                this.elements.subscribeHintElement.textContent = '';
            } else if (!planOk) {
                this.elements.subscribeHintElement.textContent = 'Please select a plan to continue.';
            } else {
                this.elements.subscribeHintElement.textContent = 'Please confirm both checkboxes above to continue.';
            }
        }
    }
}

onDomReady(() => {
    const vipSubscribeForm = new VipSubscribeForm();
}, false);